import type { PlatformTypeName } from "@multi-chat/shared";
import { cn } from "../../lib/utils.js";
import { ChannelIcon } from "./ChannelIcon.js";
import { channelBadgeClassName } from "./channel-presentation.js";

const MARK_SIZES = {
  nav: { container: "size-7", radius: "rounded-md", glyphPx: 14 },
  sm: { container: "size-8", radius: "rounded-md", glyphPx: 15 },
  md: { container: "size-10", radius: "rounded-md", glyphPx: 20 },
  list: { container: "size-12", radius: "rounded-xl", glyphPx: 24 },
  hero: { container: "size-20", radius: "rounded-2xl", glyphPx: 40 },
} as const;

/**
 * Connection-page channel identity mark.
 * Reuses Inbox ChannelIcon glyphs + channelBadgeClassName fills (gradient IG / solid WA).
 */
export function ChannelMark({
  platformType,
  size = "md",
  shape = "squircle",
  className,
}: {
  platformType: PlatformTypeName;
  size?: keyof typeof MARK_SIZES;
  shape?: "squircle" | "circle";
  className?: string;
}): React.JSX.Element {
  const mark = MARK_SIZES[size];

  return (
    <span
      className={cn(
        "inline-grid shrink-0 place-items-center text-white",
        mark.container,
        shape === "circle" ? "rounded-full" : mark.radius,
        channelBadgeClassName(platformType),
        className,
      )}
      aria-hidden="true"
    >
      <ChannelIcon platformType={platformType} size={mark.glyphPx} className="text-white" />
    </span>
  );
}
